import "./DeletedItem.css";
import { IRecord } from "../../interfaces/interfaces";
import { useRecords } from "../../hooks/useRecords";
import { restoreRecordInDb } from "../../controllers/restoreRecord";

interface props {
  record: IRecord;
}

const DeletedItem = ({ record }: props) => {
  // const { deleteRecord } = useRecords();
  const { restoreRecord, addRecord } = useRecords();

  const RestoreOneRecord = (_id: string) => {
    if (window.confirm("Do you want to restore this record?")) {
      restoreRecordInDb(_id)
        .then((restoredRecord) => {
          if (restoredRecord) {
            window.alert("The record was restored");
            restoreRecord(restoredRecord);
            addRecord(restoredRecord);
          } else {
            window.alert("The record was not restored");
          }
        })
        .catch((err) => err);
    }
  };

  return (
    <div className="Item-box">
      <div className="Item-middle-box-one">
        <p>
          <b>Nombre:</b> {record.name}
        </p>
        <p>
          <b>Teléfono:</b> {record.phone}
        </p>
      </div>
      <div className="Item-middle-box-two">
        <p>
          <b>Email:</b> {record.email}
        </p>
        <p>
          <b>Ingresado:</b> {record.date}
        </p>
      </div>
      <div className="Item-middle-box-three">
        <button
          className="Delete-button"
          onClick={() => RestoreOneRecord(record._id)}
        >
          R
        </button>
      </div>
    </div>
  );
};
export default DeletedItem;
